import { create } from 'zustand';
import { waitForPermissionAndRun } from '@utils/useWaitForPermissions';

export const useChargerCreateStore = create((set) => ({
  isOpen: false,
  payload: {},
  callback: null,

  openChargerCreate: (payload, callback = null) => {
    waitForPermissionAndRun(() => {
      set({ isOpen: true, payload, callback });
    });
  },

  close: (result) =>
    set((state) => {
      if (state.callback) state.callback(result); // run callback if exists
      return { isOpen: false, payload: {}, callback: null };
    }),
}));

// 🔥 External helper — supports callback, consistent with others
export const openChargerCreate = (payload, callback = null) => {
  const store = useChargerCreateStore.getState();
  store.openChargerCreate(payload, callback);
};

export const closeChargerCreate = () => {
  const store = useChargerCreateStore.getState();
  store.close();
};
